import type { FaireProductEntity } from "../../entity_types/product";

export const p_svretjjspy: FaireProductEntity = {
  token: "p_svretjjspy",
  type: "product",
  name: "Peru - Ghost Town - Decaf Whole Bean Coffee - 12oz",
  brandToken: "b_4db0zb0iws",
  brandName: "Partners Coffee Roasters",
  imageUrl: "https://cdn.faire.com/fastly/ddf6050597cba6cd67b08e8c7cfe82084ee24ccd8c33caf34c1079999ed217e4.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/fee842a4b8e91dae21fbffc95912d7de637a9e74c20b0f319bcb6b0045909773.jpeg",
    "https://cdn.faire.com/fastly/ac694806b173ab964ede34b3b736e4c6c94a6af88f13e5c12f847428ad924a3b.jpeg",
    "https://cdn.faire.com/fastly/f8531fe6c9b2a600f4b9bbb7417df67c8869797397ef20a5b2817cafa5f8fba2.jpeg",
    "https://cdn.faire.com/fastly/4f297c5c7375e160ec43763910c59d98951eeeefc66a5b29a67ce36e03b4d7b5.jpeg"
  ],
  priceDollars: 14.46,
  description: "Decaffeinated using mountain water to create a naturally sweet and round coffee, beginning with a subtle malt flavor, enhanced with a creamy body and rich notes of white chocolate and ending with a soft acidity and golden raisin on the finish.\n\n𝐂𝐨𝐟𝐟𝐞𝐞 𝐈𝐧𝐟𝐨\n• Source COOPAFSI\n• Tasting Notes Malt, Golden Raisin and White Chocolate\n• Elevation 1,500 - 1,750 meters\n• Region San Ignacio, Cajamarca\n• Variety Typica, Mundonovo, Caturra & Catimor\n• Process Wet-Processed, Royal Water Decaffeination\n\nA perfect fall favorite!",
  tags: [],
  msrpDollars: 25,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-09-08T20:58:10.421Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
